import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupItemTemplate: ITrialGroupItemTemplateLoadActionCreator = (groupId) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_LOAD,
            groupId
        }
    },
    LoadTrialGroupItemTemplateById: ITrialGroupItemTemplateLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupItemTemplateLoadSuccessActionCreator = (formData, formDataTrialed, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS,
            formData,
            formDataTrialed,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupItemTemplateLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupItemTemplate: ITrialGroupItemTemplateSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: ITrialGroupItemTemplateSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupItemTemplateSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupItemTemplate: ITrialGroupItemTemplateCreateActionCreator = (groupId) => {

        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_CREATE,
            groupId
        }
    },
    CreateSuccess: ITrialGroupItemTemplateCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupItemTemplateCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupItemTemplate: ITrialGroupItemTemplateValidateActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE,
            formData,
            collectionFormData
        }
    },
    ValidateSuccess: ITrialGroupItemTemplateValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupItemTemplateValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupItemTemplateClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATE_CLEAR,
            propertiesToClear
        }
    },
    Filter: ITrialGroupItemTemplateFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATES_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD = "ACTION_TRIALGROUPITEMTEMPLATE_LOAD",
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID = "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID",
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATE_SAVE = "ACTION_TRIALGROUPITEMTEMPLATE_SAVE",
    ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATE_CREATE = "ACTION_TRIALGROUPITEMTEMPLATE_CREATE",
    ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE = "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE",
    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATE_CLEAR = "ACTION_TRIALGROUPITEMTEMPLATE_CLEAR",
    ACTION_TRIALGROUPITEMTEMPLATES_FILTER = "ACTION_TRIALGROUPITEMTEMPLATES_FILTER";

export interface ITrialGroupItemTemplateLoadAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_LOAD";
    groupId: number;
}

export interface ITrialGroupItemTemplateLoadActionCreator {
    (groupId: number): ITrialGroupItemTemplateLoadAction;
}

export interface ITrialGroupItemTemplateLoadSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS";
    formData: Dtos.TrialGroupItemTemplate | Dtos.TrialGroupItemTemplate[];
    formDataTrialed: Dtos.TrialGroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate | Dtos.TrialGroupItemTemplate[],
        formDataTrialed: Dtos.TrialGroupItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateLoadSuccessAction;
}

export interface ITrialGroupItemTemplateLoadFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateLoadFailureAction;
}

export interface ITrialGroupItemTemplateLoadByIdAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupItemTemplateLoadByIdActionCreator {
    (id: number): ITrialGroupItemTemplateLoadByIdAction;
}

export interface ITrialGroupItemTemplateSaveAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_SAVE";
    formData: Dtos.TrialGroupItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface ITrialGroupItemTemplateSaveActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate,
        collectionFormData: Dtos.Collection
    ): ITrialGroupItemTemplateSaveAction;
}

export interface ITrialGroupItemTemplateSaveSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateSaveSuccessAction;
}

export interface ITrialGroupItemTemplateSaveFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateSaveFailureAction;
}

export interface ITrialGroupItemTemplateCreateAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_CREATE";
    groupId?: number;
}

export interface ITrialGroupItemTemplateCreateActionCreator {
    (groupId?: number): ITrialGroupItemTemplateCreateAction
}

export interface ITrialGroupItemTemplateCreateSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplate;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialGroupItemTemplateCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupItemTemplateCreateSuccessAction;
}

export interface ITrialGroupItemTemplateCreateFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCreateFailureAction;
}

export interface ITrialGroupItemTemplateValidateAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE";
    formData: Dtos.TrialGroupItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface ITrialGroupItemTemplateValidateActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate,
        collectionFormData: Dtos.Collection
    ): ITrialGroupItemTemplateValidateAction;
}

export interface ITrialGroupItemTemplateValidateSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplate;
    formState: Dtos.FormState;
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateValidateSuccessAction;
}

export interface ITrialGroupItemTemplateValidateFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateValidateFailureAction;
}

export interface ITrialGroupItemTemplateClearAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupItemTemplateClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupItemTemplateClearAction;
}

export interface ITrialGroupItemTemplateFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupItemTemplateFilterAction;
}

export interface ITrialGroupItemTemplateFilterAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATES_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupItemTemplateAction =
    ITrialGroupItemTemplateLoadAction |
    ITrialGroupItemTemplateLoadByIdAction |
    ITrialGroupItemTemplateLoadFailureAction |
    ITrialGroupItemTemplateLoadSuccessAction |
    ITrialGroupItemTemplateSaveAction |
    ITrialGroupItemTemplateSaveSuccessAction |
    ITrialGroupItemTemplateSaveFailureAction |
    ITrialGroupItemTemplateCreateAction |
    ITrialGroupItemTemplateCreateSuccessAction |
    ITrialGroupItemTemplateCreateFailureAction |
    ITrialGroupItemTemplateValidateAction |
    ITrialGroupItemTemplateValidateSuccessAction |
    ITrialGroupItemTemplateValidateFailureAction |
    ITrialGroupItemTemplateClearAction |
    ITrialGroupItemTemplateFilterAction;
